import { Injectable } from '@angular/core';

import { NotificationsService } from 'angular2-notifications';
import {TranslateService} from './translate.service';
// import { Overlay } from 'angular2-modal';
// import { Modal } from 'angular2-modal/plugins/bootstrap';

@Injectable()
export class NotificationService {
    private viewContainerRef: any;
    constructor(
        private notificationsService: NotificationsService,
        private translateService: TranslateService
        // private overlay: Overlay,
        // private modal: Modal
    ) { }

    public success(message: string, title?: string) {
        this.notificationsService.success(title || 'Success', this.getTranslation(message));
    }

    public error(message: string, title?: string) {
        this.notificationsService.error(title || 'Failed', this.getTranslation(message));
    }

    public alert(message: string, title?: string) {
        this.notificationsService.alert(title || 'Alert', this.getTranslation(message));
    }

    public info(message: string, title?: string) {
        this.notificationsService.info(title || 'Info', this.getTranslation(message));
    }

    public setViewContainerRef(viewContainerRef: any) {
        this.viewContainerRef = viewContainerRef;
    }

    private getTranslation(key: string): string{
        return this.translateService.translate(key);
    }

    // public openModal() {
    //     this.overlay.defaultViewContainer = this.viewContainerRef;
    //     this.modal.alert()
    //         .size('lg')
    //         .showClose(true)
    //         .title('A simple Alert style modal window2')
    //         .body(`<h4>Alert is a classic (title/body/footer) 1 button modal window that does not block.</h4>`)
    //         .open();
    // }
}



// WEBPACK FOOTER //
// ./src/app/core/services/notification.service.ts